<template>
  <div class="login_remis_customer">
    <div class="container">
      <div class="row">
        <transition name="right-slide" appear>
          <div class="col-md-6 login_remis_first_section">
            <div v-if="windowLoc == 'localhost' || windowLoc == 'efueling'">
              <img
                src="https://epump.com.ng/images/logo2.svg"
                class="company_logo"
                width="120"
              />

              <div class="login_remis_text">
                {{ $t("text.signUp.manageFueling") }}
              </div>
            </div>
            <!-- partnership logo -->
            <div v-else>
              <div class="partners_div mb-4" style="margin-right: 17%">
                <div>
                  <img
                    src="@/assets/img/FuelMetrics.png"
                    class="mr-4"
                    width="100px"
                  />
                </div>
                <div class="vl"></div>
                <div>
                  <img
                    :src="[
                      windowLoc == 'interswitchenergy'
                        ? require('@/assets/img/ISW- Logo.png')
                        : windowLoc == 'rainoil'
                        ? require('@/assets/img/rainoil_1a.jpg')
                        : windowLoc == 'eterna'
                        ? require('@/assets/img/Eterna-logo_1a.jpg')
                        : windowLoc == 'bovas'
                        ? require('@/assets/img/bovas_1a.png')
                        : 'https://epump.com.ng/images/logo2.svg',
                    ]"
                    class="ml-4"
                    width="100px"
                    height="50px"
                  />
                </div>
              </div>
            </div>

            <div class="row m-hide pt-3">
              <div
                class="col-md-6 col-sm-12 login-remis-img remove-left-padding"
              >
                <img src="../../assets/img/cars.png" />
              </div>
              <div
                class="col-md-6 col-sm-12 login-remis-img remove-left-padding"
              >
                <img src="../../assets/img/nossel.png" />
              </div>
              <div
                class="col-md-6 col-sm-12 login-remis-img mt-3 remove-left-padding"
              >
                <img src="../../assets/img/motorbike-fleet.png" />
              </div>
              <div class="col-md-6 login-remis-img mt-3 remove-left-padding">
                <img src="../../assets/img/car-speed.png" />
              </div>
            </div>
          </div>
        </transition>
        <div class="col-md-6">
          <transition name="slide-fade" appear>
            <div
              class="login_remis_section mx-0 signup_remis_section remis_position"
            >
              <h4
                :style="[
                  windowLoc == 'interswitchenergy'
                    ? { color: '#11386a' }
                    : windowLoc == 'rainoil'
                    ? { color: '#0a0044' }
                    : windowLoc == 'eterna'
                    ? { color: '#007236' }
                    : windowLoc == 'bovas'
                    ? { color: '#ffc905' }
                    : null,
                ]"
              >
                {{ $t("text.signUp.register") }}
              </h4>
              <form>
                <div class="row">
                  <div class="remis_login_field col-md-6 col-sm-12">
                    <label>{{ $t("text.signUp.firstName") }}</label>
                    <input
                      v-model="firstname"
                      @blur="checkFirstName"
                      :class="!firstnameFormatGood ? 'red_back' : null"
                    />
                  </div>
                  <div class="remis_login_field col-md-6 col-sm-12">
                    <label>{{ $t("text.signUp.lastName") }}</label>
                    <input
                      v-model="lastname"
                      @blur="checkLastName"
                      :class="!lastnameFormatGood ? 'red_back' : null"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="remis_login_field col-md-6 col-sm-12">
                    <label>{{ $t("text.signUp.emailAddress") }}</label>
                    <input
                      v-model="email"
                      @blur="checkEmail"
                      :class="!emailFormatGood ? 'red_back' : null"
                    />
                  </div>
                  <div class="remis_login_field col-md-6 col-sm-12">
                    <label>{{ $t("text.signUp.phoneNumber") }}</label>
                    <input
                      type="number"
                      v-model="phoneNumber"
                      @blur="checkPhoneNumber"
                      :class="!phoneFormatGood ? 'red_back' : null"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="remis_login_field col-md-12 col-sm-12">
                    <label>{{ $t("text.signUp.password") }}</label>
                    <div class="position-relative">
                      <input
                        type="password"
                        ref="pass"
                        v-model="password"
                        class="w-100"
                        @blur="checkPassword"
                        @input="checkPassword2"
                        :class="!passwordFormatGood ? 'red_back' : null"
                      />
                      <i
                        class="fa eye-icon cursor-pointer"
                        aria-hidden="true"
                        :class="[showPass ? 'fa-eye-slash' : 'fa-eye']"
                        @click="toggleEyeIcon('pass')"
                      ></i>
                    </div>
                  </div>
                  <!-- <div class="remis_login_field col-md-6 col-sm-12">
                                <label>Confirm password</label>
                                 <div class="position-relative">
                                    <input type="password" ref="confPass" v-model="confirmPassword" class="w-100" @blur="checkConfPassword" :class="!confPasswordFormatGood ? 'red_back' : null"/>
                                    <i class="fa eye-icon cursor-pointer" aria-hidden="true" :class="[showConfPass ? 'fa-eye-slash' : 'fa-eye']" @click="toggleEyeIcon('confPass')"></i>
                                </div>
                            </div> -->
                </div>

                <div>
                  <ul>
                    <li :class="hasUppercase ? 'text-success' : 'text-danger'">
                      {{ $t("text.omit.oneUpper") }}
                    </li>
                    <li :class="hasNumber ? 'text-success' : 'text-danger'">
                      {{ $t("text.omit.oneNum") }}
                    </li>
                    <li :class="hasSymbol ? 'text-success' : 'text-danger'">
                      {{ $t("text.omit.oneSpec") }}
                    </li>
                    <li :class="isMinLength ? 'text-success' : 'text-danger'">
                      {{ $t("text.omit.eightChar") }}
                    </li>
                  </ul>
                </div>

                <button
                  @click="signup"
                  :disabled="disableButton"
                  :class="disableButton ? 'login_loading' : null"
                  :style="[
                    windowLoc == 'interswitchenergy'
                      ? { backgroundColor: '#11386a' }
                      : windowLoc == 'rainoil'
                      ? { backgroundColor: '#0a0044' }
                      : windowLoc == 'eterna'
                      ? { backgroundColor: '#007236' }
                      : windowLoc == 'bovas'
                      ? { backgroundColor: '#ffc905' }
                      : null,
                  ]"
                >
                  <p v-if="!disableButton">{{ $t("text.signUp.register") }}</p>
                  <div class="loader_spinner">
                    <pulse-loader
                      :color="color"
                      size="15px"
                      v-if="disableButton"
                    ></pulse-loader>
                  </div>
                </button>
                <p class="text-center">
                  {{ $t("text.signUp.existingAccount") }}
                  <router-link
                    :to="{ name: 'login' }"
                    class="remis_sign_up_link"
                    :style="[
                      windowLoc == 'interswitchenergy'
                        ? { color: '#11386a' }
                        : windowLoc == 'rainoil'
                        ? { color: '#0a0044' }
                        : windowLoc == 'eterna'
                        ? { color: '#007236' }
                        : windowLoc == 'bovas'
                        ? { color: '#ffc905' }
                        : null,
                    ]"
                    >{{ $t("text.signUp.signIn") }}</router-link
                  >
                </p>
              </form>
            </div>
          </transition>
        </div>
        <SuccessfulModal />
      </div>
    </div>
  </div>
</template>

<script>
import configObject from "@/config";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import SuccessfulModal from "@/components/modals//successfulSignUp.vue";

export default {
  title: "Signup - Epump  Portal",
  components: {
    PulseLoader,
    SuccessfulModal,
  },
  data() {
    return {
      color: this.$store.getters.getDatePickerColor,
      firstname: "",
      lastname: "",
      email: "",
      phoneNumber: null,
      password: "",
      confirmPassword: "",
      disableButton: false,
      emailFormatGood: true,
      confPasswordFormatGood: true,
      passwordFormatGood: true,
      phoneFormatGood: true,
      firstnameFormatGood: true,
      lastnameFormatGood: true,
      showPass: false,
      showConfPass: false,
      windowLoc: window.location.hostname.split(".")[0],

      hasUppercase: false,
      hasNumber: false,
      hasSymbol: false,
      isMinLength: false,
    };
  },
  methods: {
    toggleEyeIcon(mode) {
      if (mode === "pass") {
        this.showPass = !this.showPass;
        this.$refs.pass.type === "text"
          ? (this.$refs.pass.type = "password")
          : (this.$refs.pass.type = "text");
      } else {
        this.showConfPass = !this.showConfPass;
        this.$refs.confPass.type === "text"
          ? (this.$refs.confPass.type = "password")
          : (this.$refs.confPass.type = "text");
      }
    },
    validEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      }
      return false;
    },
    checkPassword2() {
      const uppercasePattern = /[A-Z]/;
      const numberPattern = /[0-9]/;
      const symbolPattern = /[!@#$%^&*(),.?":{}|<>]/;

      this.hasUppercase = uppercasePattern.test(this.password);
      this.hasNumber = numberPattern.test(this.password);
      this.hasSymbol = symbolPattern.test(this.password);
      this.isMinLength = this.password.length >= 8;
    },
    checkFirstName() {
      if (!this.firstname) {
        this.$toast.open({
          message: this.$t("text.errors.firstNameMissing"),
          type: "error",
          duration: 3500,
        });
        this.firstnameFormatGood = false;
        return;
      }
      this.firstnameFormatGood = true;
    },
    checkLastName() {
      if (!this.lastname) {
        this.$toast.open({
          message: this.$t("text.errors.lastNameMissing"),
          type: "error",
          duration: 3500,
        });
        this.lastnameFormatGood = false;
        return;
      }
      this.lastnameFormatGood = true;
    },
    checkEmail() {
      if (!this.email) {
        this.$toast.open({
          message: this.$t("text.errors.emailMissing"),
          type: "error",
          duration: 3500,
        });
        this.emailFormatGood = false;
        return;
      }
      if (!this.validEmail(this.email)) {
        this.$toast.open({
          message: this.$t("text.errors.invalidEmail"),
          type: "error",
          duration: 5000,
        });
        this.emailFormatGood = false;
        return;
      }
      this.emailFormatGood = true;
    },
    checkConfPassword() {
      if (!this.confirmPassword) {
        this.$toast.open({
          message: this.$t("text.errors.confirmPassword"),
          type: "error",
          duration: 3500,
        });
        this.confPasswordFormatGood = false;
        return;
      }
      if (this.password.length !== this.confirmPassword.length) {
        this.$toast.open({
          message: this.$t("text.errors.passwordMatch"),
          type: "error",
          duration: 3500,
        });
        this.confPasswordFormatGood = false;
        return;
      }
      this.confPasswordFormatGood = true;
    },
    checkPassword() {
      if (!this.password) {
        this.$toast.open({
          message: this.$t("text.errors.passwordMissing"),
          type: "error",
          duration: 3500,
        });
        this.passwordFormatGood = false;
        return;
      }
      if (this.password.length < 6 || this.password.length > 100) {
        this.$toast.open({
          message: this.$t("text.errors.shortPassword"),
          type: "error",
          duration: 3500,
        });
        this.passwordFormatGood = false;
        return;
      }
      this.passwordFormatGood = true;
    },
    checkPhoneNumber() {
      if (!this.phoneNumber) {
        this.$toast.open({
          message: this.$t("text.errors.contactPhoneMissing"),
          type: "error",
          duration: 3500,
        });
        this.phoneFormatGood = false;
        return;
      }
      if (this.phoneNumber.length < 10 || this.phoneNumber.length > 13) {
        this.$toast.open({
          message: this.$t("text.errors.shortPhoneNumber"),
          type: "error",
          duration: 2000,
        });
        this.phoneFormatGood = false;
        return;
      }
      this.phoneFormatGood = true;
    },
    emptyFields() {
      (this.email = ""),
        (this.firstname = ""),
        (this.lastname = ""),
        (this.password = ""),
        (this.phoneNumber = null);
    },
    signup($event) {
      $event.preventDefault();

      this.checkFirstName();
      if (!this.firstnameFormatGood) return;
      this.checkLastName();
      if (!this.lastnameFormatGood) return;
      this.checkEmail();
      if (!this.emailFormatGood) return;
      this.checkPhoneNumber();
      if (!this.phoneFormatGood) return;
      this.checkPassword();
      if (!this.passwordFormatGood) return;
      // this.checkConfPassword()
      // if (!this.confPasswordFormatGood) return

      if (
        !this.hasUppercase ||
        !this.hasNumber ||
        !this.hasSymbol ||
        !this.isMinLength
      ) {
        this.$toast.open({
          message: this.$t("text.omit.passRequirement"),
          type: "error",
          duration: 3000,
        });

        return;
      }

      this.disableButton = true;
      let data = {
        userName: this.email,
        firstName: this.firstname,
        lastName: this.lastname,
        password: this.password,
        phone: this.phoneNumber,
        confirmPassword: this.password,
      };

      // console.log(data);

      this.axios
        .post(
          `${configObject.apiBaseUrl}/Account/Register`,
          data,
          configObject.authConfig()
        )
        .then((response) => {
          this.disableButton = false;
          this.$modal.show("successfulSignUpModal");
          this.emptyFields();
        })
        .catch((error) => {
          this.disableButton = false;
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 10000,
          });
        });
    },
  },
};
</script>

<style scoped>
.right-slide-enter-active {
  transition: all 0.9s ease;
}
.right-slide-leave-active {
  transform: translateX(50px);
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.right-slide-enter,
.right-slide-leave-to {
  transform: translateX(-50px);
  opacity: 0;
}
ul {
  list-style-type: none;
  padding: 0;
}

li::before {
  content: "";
  display: inline-block;
  width: 1em;
  margin-right: 0.5em;
  font-size: 0.9em; /* Set the size of the icons */
}

.text-success::before {
  content: "✅";
  color: green; /* Ensure the color is set for the checkmark */
}

.text-danger::before {
  content: "❌";
  color: red; /* Set the color for the X icon */
  font-size: 0.7em; /* Ensure the icon size is consistent */
}
</style>
